var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg001TrafficCone = function Svg001TrafficCone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M402.689 359.11 256 432.47l-146.689-73.36 15.975-63.909L0 361l256 135 256-135-125.286-65.799zM335.601 214.42l-7.452-29.805L256 220.697l-72.151-36.079-7.45 29.804L256 254.242z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m367.753 343.041-24.699-98.802L256 287.787l-87.056-43.546-24.697 98.8L256 398.925zM320.697 154.796l-7.453-29.806L256 153.607l-57.246-28.61-7.451 29.802L256 187.152zM305.792 95.171 286 16h-60l-19.794 79.178L256 120.063z"
  })));
};
export default Svg001TrafficCone;